"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCALE_TIMEOUT = exports.SCALE_Y_CLASSNAMES = exports.SCALE_CLASSNAMES = exports.CROSS_FADE_CLASSNAMES = exports.CROSS_FADE_TIMEOUT = exports.DEFAULT_COLLAPSE_MIN_PADDING_BOTTOM = exports.DEFAULT_COLLAPSE_MIN_PADDING_TOP = exports.DEFAULT_COLLAPSE_MIN_HEIGHT = exports.COLLAPSE_TIMEOUT = exports.UNMOUNT = exports.EXITED = exports.EXITING = exports.EXIT = exports.ENTERED = exports.ENTERING = exports.ENTER = void 0;
exports.ENTER = "enter";
exports.ENTERING = "entering";
exports.ENTERED = "entered";
exports.EXIT = "exit";
exports.EXITING = "exiting";
exports.EXITED = "exited";
exports.UNMOUNT = "unmount";
exports.COLLAPSE_TIMEOUT = {
    enter: 250,
    exit: 200,
};
exports.DEFAULT_COLLAPSE_MIN_HEIGHT = 0;
exports.DEFAULT_COLLAPSE_MIN_PADDING_TOP = 0;
exports.DEFAULT_COLLAPSE_MIN_PADDING_BOTTOM = 0;
exports.CROSS_FADE_TIMEOUT = {
    enter: 300,
    exit: 0,
};
exports.CROSS_FADE_CLASSNAMES = {
    appear: "rmd-cross-fade",
    appearActive: "rmd-cross-fade--active",
    enter: "rmd-cross-fade",
    enterActive: "rmd-cross-fade--active",
};
exports.SCALE_CLASSNAMES = {
    appear: "rmd-transition--scale-enter",
    appearActive: "rmd-transition--scale-enter-active",
    enter: "rmd-transition--scale-enter",
    enterActive: "rmd-transition--scale-enter-active",
    enterDone: "",
    exit: "rmd-transition--scale-exit",
    exitActive: "rmd-transition--scale-exit-active",
};
exports.SCALE_Y_CLASSNAMES = {
    appear: "rmd-transition--scale-y-enter",
    appearActive: "rmd-transition--scale-y-enter-active",
    enter: "rmd-transition--scale-y-enter",
    enterActive: "rmd-transition--scale-y-enter-active",
    enterDone: "",
    exit: "rmd-transition--scale-y-exit",
    exitActive: "rmd-transition--scale-y-exit-active",
};
exports.SCALE_TIMEOUT = {
    enter: 200,
    exit: 150,
};
//# sourceMappingURL=constants.js.map